export enum ContextInfoCustomFormType {
    BUILDING = 'building',
    COMPLETED_DATE = 'completeddate',
    EVALUATOR = 'evaluator',
    START_DATE = 'startdare',
    TARGET = 'target'
}
